export const ASYNC_FETCH = 'ITP_Remarks/ASYNC_FETCH';
export const ASYNC_FETCH_SUCCESSPLAN = 'ITP_Remarks/ASYNC_FETCH_SUCCESSPLAN';
export const ASYNC_FETCH_FAILURE = 'ITP_Remarks/ASYNC_FETCH_FAILURE';export const SET_SELECTED_REMARK = 'ITP_GenerateRemarks/SET_SELECTED_REMARK';
export const SET_CONFIRM_PLANCHANGE = 'ITP_GenerateRemarks/SET_CONFIRM_PLANCHANGE'
export const SET_ISREMARKS_LOAD = 'ITP_Remarks/SET_ISREMARKS_LOAD';
export const SET_ISREDIRECT_TO_HUB = 'ITP_Remarks/SET_ISREDIRECT_TO_HUB';


